import { Map } from 'immutable';

export function clearToken() {
  localStorage.removeItem('id_token');
  localStorage.removeItem('idusuario');
  localStorage.removeItem('rut');
  localStorage.removeItem('nombre')
  localStorage.removeItem('apellido')
  localStorage.removeItem('email')
  localStorage.removeItem('idperfil')
  localStorage.removeItem('perfil')
  localStorage.removeItem('idcomercio')
  localStorage.removeItem('comercio')
  localStorage.removeItem('idsucursal')
  localStorage.removeItem('sucursal')
  localStorage.removeItem('imagen')
}

export function getToken() {
  try {
    const idToken = localStorage.getItem('token');
    const IdUsuario = localStorage.getItem('idusuario');
    const Rut = localStorage.getItem('rut');
    const Nombre = localStorage.getItem('nombre');
    const Apellido = localStorage.getItem('apellido');
    const Email = localStorage.getItem('email');
    const IdPerfil = localStorage.getItem('idperfil');
    const Perfil = localStorage.getItem('perfil');
    const IdComercio = localStorage.getItem('idcomercio');
    const Comercio = localStorage.getItem('comercio');
    const IdSucursal = localStorage.getItem('idsucursal');
    const Sucursal = localStorage.getItem('sucursal');
    const Imagen = localStorage.getItem('imagen');

    return new Map(
      {
        idToken,
        IdUsuario,
        Rut,
        Nombre,
        Apellido,
        Email,
        IdPerfil,
        Perfil,
        IdComercio,
        Comercio,
        IdSucursal,
        Sucursal,
        Imagen
      });
  } catch (err) {
    clearToken();
    return new Map();
  }
}

export function arrayEqual(array1, array2) {
  return array1.sort().toString() === array2.sort().toString();
}

export function timeDifference(givenTime) {
  givenTime = new Date(givenTime);
  const milliseconds = new Date().getTime() - givenTime.getTime();
  const numberEnding = number => {
    return number > 1 ? 's' : '';
  };
  const number = num => (num > 9 ? '' + num : '0' + num);
  const getTime = () => {
    let temp = Math.floor(milliseconds / 1000);
    const years = Math.floor(temp / 31536000);
    if (years) {
      const month = number(givenTime.getUTCMonth() + 1);
      const day = number(givenTime.getUTCDate());
      const year = givenTime.getUTCFullYear() % 100;
      return `${day}-${month}-${year}`;
    }
    const days = Math.floor((temp %= 31536000) / 86400);
    if (days) {
      if (days < 28) {
        return days + ' day' + numberEnding(days);
      } else {
        const months = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];
        const month = months[givenTime.getUTCMonth()];
        const day = number(givenTime.getUTCDate());
        return `${day} ${month}`;
      }
    }
    const hours = Math.floor((temp %= 86400) / 3600);
    if (hours) {
      return `${hours} hour${numberEnding(hours)} ago`;
    }
    const minutes = Math.floor((temp %= 3600) / 60);
    if (minutes) {
      return `${minutes} minute${numberEnding(minutes)} ago`;
    }
    return 'a few seconds ago';
  };
  return getTime();
}

export function stringToInt(value, defValue = 0) {
  if (!value) {
    return 0;
  } else if (!isNaN(value)) {
    return parseInt(value, 10);
  }
  return defValue;
}
export function stringToPosetiveInt(value, defValue = 0) {
  const val = stringToInt(value, defValue);
  return val > -1 ? val : defValue;
}
